<template>
  <div class="top" v-show="saver || lang || mess" :style="bag ? 'background-color:transparent;' : ''">
    <div class="top_r">
      <!-- <i v-if="saver" class="material-icons" @click="$router.push('/serve')">support_agent</i>
      <i v-if="lang" class="material-icons" @click="$router.push('/lang')">language</i>
      <i v-if="mess" style="font-size: .56rem" class="material-icons" @click="$router.push('/system_messages')">notifications_none</i> -->

      <!-- 客服support_agent -->
      <svg v-if="saver" @click="$router.push('/serve')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        width=".6rem" height=".6rem" fill="rgba(255,255,255,1)">
        <path
          d="M21 8C22.1046 8 23 8.89543 23 10V14C23 15.1046 22.1046 16 21 16H19.9381C19.446 19.9463 16.0796 23 12 23V21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V16H3C1.89543 16 1 15.1046 1 14V10C1 8.89543 1.89543 8 3 8H4.06189C4.55399 4.05369 7.92038 1 12 1C16.0796 1 19.446 4.05369 19.9381 8H21ZM7.75944 15.7849L8.81958 14.0887C9.74161 14.6662 10.8318 15 12 15C13.1682 15 14.2584 14.6662 15.1804 14.0887L16.2406 15.7849C15.0112 16.5549 13.5576 17 12 17C10.4424 17 8.98882 16.5549 7.75944 15.7849Z">
        </path>
      </svg>

      <!-- 语言language -->
      <svg v-if="lang" @click="$router.push('/lang')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        width=".6rem" height=".6rem" fill="rgba(255,255,255,1)">
        <path
          d="M6.23509 6.45329C4.85101 7.89148 4 9.84636 4 12C4 16.4183 7.58172 20 12 20C13.0808 20 14.1116 19.7857 15.0521 19.3972C15.1671 18.6467 14.9148 17.9266 14.8116 17.6746C14.582 17.115 13.8241 16.1582 12.5589 14.8308C12.2212 14.4758 12.2429 14.2035 12.3636 13.3943L12.3775 13.3029C12.4595 12.7486 12.5971 12.4209 14.4622 12.1248C15.4097 11.9746 15.6589 12.3533 16.0043 12.8777C16.0425 12.9358 16.0807 12.9928 16.1198 13.0499C16.4479 13.5297 16.691 13.6394 17.0582 13.8064C17.2227 13.881 17.428 13.9751 17.7031 14.1314C18.3551 14.504 18.3551 14.9247 18.3551 15.8472V15.9518C18.3551 16.3434 18.3168 16.6872 18.2566 16.9859C19.3478 15.6185 20 13.8854 20 12C20 8.70089 18.003 5.8682 15.1519 4.64482C14.5987 5.01813 13.8398 5.54726 13.575 5.91C13.4396 6.09538 13.2482 7.04166 12.6257 7.11976C12.4626 7.14023 12.2438 7.12589 12.012 7.11097C11.3905 7.07058 10.5402 7.01606 10.268 7.75495C10.0952 8.2232 10.0648 9.49445 10.6239 10.1543C10.7134 10.2597 10.7307 10.4547 10.6699 10.6735C10.59 10.9608 10.4286 11.1356 10.3783 11.1717C10.2819 11.1163 10.0896 10.8931 9.95938 10.7412C9.64554 10.3765 9.25405 9.92233 8.74797 9.78176C8.56395 9.73083 8.36166 9.68867 8.16548 9.64736C7.6164 9.53227 6.99443 9.40134 6.84992 9.09302C6.74442 8.8672 6.74488 8.55621 6.74529 8.22764C6.74529 7.8112 6.74529 7.34029 6.54129 6.88256C6.46246 6.70541 6.35689 6.56446 6.23509 6.45329ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z">
        </path>
      </svg>
      <!-- 消息notifications_none -->
      <svg v-if="mess" @click="$router.push('/system_messages')" t="1748486708493" class="icon" viewBox="0 0 1024 1024"
        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18639" width=".6rem" height=".6rem">
        <path
          d="M823.04 727.04L768 672v-213.333333c0-130.986667-69.973333-240.64-192-269.653334v-29.013333c0-35.413333-28.586667-64-64-64s-64 28.586667-64 64v29.013333C325.546667 218.026667 256 327.253333 256 458.666667v213.333333l-55.04 55.04c-26.88 26.88-8.106667 72.96 29.866667 72.96h561.92c38.4 0 57.173333-46.08 30.293333-72.96zM682.666667 714.666667H341.333333v-256c0-105.813333 64.426667-192 170.666667-192s170.666667 86.186667 170.666667 192v256z m-170.666667 213.333333c46.933333 0 85.333333-38.4 85.333333-85.333333h-170.666666a85.333333 85.333333 0 0 0 85.333333 85.333333z"
          p-id="18640" fill="#ffffff"></path>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    lang: {
      type: Boolean,
      default: false
    },
    saver: {
      type: Boolean,
      default: false
    },
    mess: {
      type: Boolean,
      default: false
    },
    bag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      scrollPosition: null,
    }
  },
  mounted() {
    this.updateScroll();
    window.addEventListener('scroll', this.updateScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.updateScroll);
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      // console.log(this.scrollPosition);
      if (!this.$el || !this.$el.classList) return;
      this.$el.classList.toggle('active', this.scrollPosition > 0);
    }
  },
}
</script>
<style lang="less" scoped>
.active {
  background-color: #121212;
  border-bottom: #444 .04rem solid;
}

.material-icons {
  color: #fff;
  font-size: .56rem;
}

.top {
  height: 1.15rem;
  width: 100%;
  max-width: 560PX;
  display: flex;
  justify-content: flex-end;
  padding: 0 .4rem;
  position: fixed;
  top: 0;
  z-index: 10;
  transition: all ease 0.5s;
  -webkit-transition: all ease 0.5s;

  .top_r {
    display: flex;
    gap: .5rem;
    align-items: center;
  }
}
</style>
